<script>
    import { createEventDispatcher } from "svelte";
  
    import { getDateRows, uuid, noop } from "../date-time.js";
    
    const dispatch = createEventDispatcher();
  
    // props
    export let date;
    export let month;
    export let year;
    export let isAllowed;
  
    // local vars to help in render
    const weekdays = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
    let cells;
  
    // function helpers
    const onChange = date => {
      dispatch("datechange", new Date(year, month, date));
    };

    const onKeydown = (e, value) => {
      if (e.key == "Escape") dispatch("escape");
      
      if (e.key == "Tab" && !e.shiftKey) {
        // if this is the last focusable day in the date picker then user just tabbed out so dispatch an event 
        if (value == cells.filter(c => c.value && c.allowed).length) {
          dispatch("tabout");
        }
      }
    }
  
    const allow = (year, month, date) => {
      if (!date) return true;
      return isAllowed(new Date(year, month, date));
    };
  
    $: cells = getDateRows(month, year).map(c => ({
      value: c,
      allowed: allow(year, month, c)
    }));
  </script>
  
  <style>
    .calendar-container {
      margin-top: 8px;
      padding: 6px;
      width: 370px;
      box-sizing: content-box;
    }

    .calendar-row {
      display: flex;
      margin: 2px 6px;
      flex-wrap: wrap;
      box-sizing: content-box;
      width: 100%;
    }
  
    .cell {
      display: inline-block;
      width: 45px;
      height: 20px;
      text-align: center;
      padding: 2px;
      padding-bottom: 7px;
      margin: 1px;
      box-sizing: content-box;
    }
  
    .selected {
      background: #3d5980;
      color: #fff;
    }
  
    .highlight {
      transition: transform 0.2s cubic-bezier(0.165, 0.84, 0.44, 1);
    }
  
    .disabled {
      background: #efefef;
      cursor: not-allowed;
      color: #bfbfbf;
    }
  
    .highlight:hover, .highlight:focus-visible {
      background: #fa8072;
      color: #fff;
      cursor: pointer;
      transform: scale(1.3);
    } 
  
    .selected.highlight:hover {
      background: #fa8072;
    }
  </style>
  
  <div class="calendar-container">
    <div class="calendar-row">
      {#each weekdays as day}
        <div class="cell">{day}</div>
      {/each}
    </div>
  
    <div class="calendar-row">
      {#each cells as { allowed, value } (uuid())}
        {#if allowed && value}
          <button class="button-reset focus-outline cell"
            on:click={allowed && value ? onChange.bind(this, value) : noop}
            on:keydown={(e) => {onKeydown(e,value)}}
            class:highlight={allowed && value}
            class:selected={new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime() === new Date(year, month, value).getTime()}>
            {value || ''}
          </button>
        {:else}
          <div class="cell" class:disabled={!allowed}>
            {value || ''}
          </div>
        {/if}
      {/each}
    </div>
  </div>
  